import * as api from '../../api/api-visar-rendicion-recupero';
import { 
    OBTENER_LLAVES

} from '../types';

export const obtenerDatosLlaves = (llaves) => ({
    type:OBTENER_LLAVES,
    payload: llaves
});

